module.exports = __webpack_public_path__ + "img/photos-icon.48e95700.png";